/* eslint-disable import/first */

import React, { Suspense, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";

import Header from "components/header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import posts from "components/Blog/Post.jsx";
import "App.css";
import { NavButtonClosed } from "StateManagement/Context";
import ScrollToTopOnNavigate from "components/ScrollToTopOnNavigate";
import PageNotFound from "components/404";

const Home = React.lazy(() => import("pages/Home/Home.js"));
const BookAdemo = React.lazy(() => import("components/BookDemo/BookADemo.jsx"));
const Blog = React.lazy(() => import("components/Blog/Blog.jsx"));
const FleetManagementServicesSolutions = React.lazy(
  () => import("components/Blog/FleetManagementServicesSolutions.jsx")
);
const CommercialVehicleTrackingSystem = React.lazy(
  () => import("components/Blog/CommercialVehicleTrackingSystem.jsx")
);
const VehicleAlignment = React.lazy(
  () => import("components/Blog/VehicleAlignment.jsx")
);
const VehicleDailyChecksImportance = React.lazy(
  () => import("components/Blog/VehicleDailyChecksImportance.jsx")
);
const PricingPlan = React.lazy(() => import("components/PricingPlan.js/PricingPlan"));
const PrivacyPolicy = React.lazy(
  () => import("pages/Privacy Policy/PrivacyPolicy")
);
const AboutUs = React.lazy(() => import("pages/AboutUs/AboutUs"));
const ContactUs = React.lazy(() => import("pages/ContactUs/ContactUs"));
const APKDownload = React.lazy(() => import("pages/APKDownload/APKDownload"));



function App() {
  const [navButtonClosed, setNavButtonClosed] = useState(false);
  return (
    <Router>
      <ScrollToTopOnNavigate />
      <NavButtonClosed.Provider value={{ navButtonClosed, setNavButtonClosed }}>
        <Header />
      </NavButtonClosed.Provider>

      <Suspense fallback={<div className="text-center py-5">Loading…</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/book-a-demo"
            element={<BookAdemo title="Book A Demo" />}
          />
          <Route path="/blog" element={<Blog post={posts} />} />
          {/* <Route
            path="/order-a-device"
            element={<OrderDevice title="Order a Device" />}
          /> */}
          {/* <Route
            path="/get-a-free-quote"
            element={<RequestAQuote title="Request A Quote" />}
          /> */}
          <Route
            path="/fleet-management-services-solutions"
            element={
              <FleetManagementServicesSolutions title="Fleet Management Services Solutions" />
            }
          />
          <Route
            path="/commercial-vehicle-tracking-system"
            element={
              <CommercialVehicleTrackingSystem title="Commercial Vehicle Tracking System" />
            }
          />
          <Route
            path="/vehicle-alignment"
            element={<VehicleAlignment title="VehicleAlignment" />}
          />
          <Route
            path="/vehicle-daily-checks-importance"
            element={
              <VehicleDailyChecksImportance title="Vehicle Daily Checks Importance" />
            }
          />
          <Route
            path="/pricing-plan"
            element={<PricingPlan title="Pricing Plan" />}
          />
          <Route path="/about-us" element={<AboutUs title="About Us" />} />
          <Route path="/contact-us" element={<ContactUs title="Contact Us" />} />
          <Route
            path="/apk-download"
            element={<APKDownload title="APK Download" />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy title="Privacy Policy" />}
          />
          <Route path="*" element={<PageNotFound title="404" />} />
        </Routes>
      </Suspense>

      <Footer />
    </Router>
  );
}

export default App;
